export const CustomerTableColumn = [
    {
      field: 'id',
      headerName: 'STT',
      minWidth: 30,
      maxWidth: 50,
      flex: 1,
      hide: true,
      sortable: false,
    },
    {
      field: 'customerCode',
      headerName: 'Mã khách hàng',
      minWidth: 150,
      maxWidth: 200,
      flex: 1,
      sortable: false,
    },
    {
      field: 'customerType',
      headerName: 'Loại khách hàng',
      minWidth: 150,
      maxWidth: 200,
      flex: 1,
      sortable: false,
    },
    {field: 'name', headerName: 'Tên', width: 150, flex: 1, sortable: false},
    {
      field: 'identificationNumber',
      headerName: 'CMND/MST',
      minWidth: 150,
      maxWidth: 200,
      flex: 1,
      sortable: false,
    },
    {
      field: 'address',
      headerName: 'Địa chỉ',
      minWidth: 150,
      maxWidth: 200,
      flex: 1,
      sortable: false,
    },
  ]